
define('text!modules/audiences/segments/templates/newRow.html',[],function () { return '<tr>\n\t<td class=\'checkbox\'>\n\t\t<strand-checkbox></strand-checkbox>\n\t</td>\n\t<td>\n\t\t<span class=\'name\'>{{displayName}} {{displayId}}\n\t</td>\n\t</span>\n</tr>\n';});

